// components/utils/FilterModal.jsx

import React from "react";

const FilterModal = ({
  show,
  mode, // "load" | "save" | "delete"
  filtersList,

  selectedFilterId,
  setSelectedFilterId,

  newFilterName,
  setNewFilterName,

  onClose,
  onConfirm
}) => {
  if (!show) return null;

  const isSave = mode === "save";
  const isDelete = mode === "delete";
  const isLoad = mode === "load";

  const isDisabled =
    isSave
      ? (!selectedFilterId && !newFilterName?.trim())
      : !selectedFilterId;

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog">
        <div className="modal-content">

          {/* HEADER */}
          <div className="modal-header">
            <h5 className="modal-title">
              {isLoad && "Filter laden"}
              {isSave && "Filter speichern"}
              {isDelete && "Filter löschen"}
            </h5>

            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            />
          </div>

          {/* BODY */}
          <div className="modal-body">

            {/* Wenn keine Filter existieren → Hinweis anzeigen */}
            {filtersList.length === 0 ? (
              <p>Keine gespeicherten Filter vorhanden.</p>
            ) : (
              <>
                <label className="form-label">
                  Gespeicherte Filter
                </label>

                <select
                  className="form-select"
                  value={selectedFilterId || ""}
                  onChange={(e) => setSelectedFilterId(e.target.value)}
                >
                  <option value="">-- Bitte wählen --</option>

                  {filtersList.map((f) => (
                    <option key={f.id} value={f.id}>
                      {f.name}
                    </option>
                  ))}
                </select>
              </>
            )}

            {/* SAVE MODE: create new filter */}
            {isSave && (
              <div className="mt-3">
                <label className="form-label">
                  Neuer Filtername
                </label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="z.B. Meine CH-Sammlung"
                  value={newFilterName || ""}
                  onChange={(e) => setNewFilterName(e.target.value)}
                />

                <small className="text-muted d-block mt-2">
                  Wenn ein Filter ausgewählt ist → wird überschrieben.  
                  Wenn leer → neuer Filter wird erstellt.
                </small>
              </div>
            )}
          </div>

          {/* FOOTER */}
          <div className="modal-footer">

            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Abbrechen
            </button>

            <button
              type="button"
              className={
                isDelete ? "btn btn-danger" : "btn btn-primary"
              }
              onClick={onConfirm}
              disabled={isDisabled}
            >
              {isLoad && "Laden"}
              {isSave && "Speichern"}
              {isDelete && "Löschen"}
            </button>

          </div>

        </div>
      </div>
    </div>
  );
};

export default FilterModal;